import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp',
)({
  component: function WhatsAppSistemaLayoutRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.CONVERSATIONS} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
